import { User } from 'firebase/auth'
import * as Sentry from '@sentry/browser'

// Sentry-only user tagging. Does not register the user with any analytics pipeline.
export function setSentryUser(user: User | null) {
  if (user == null) return

  const userProperties = {
    id: user.uid,
    ...(user.email && { email: user.email }),
  }

  Sentry.setUser(userProperties)
}
